// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"60c2c17b","2457":"60c2c17b","3613":"60c2c17b","4843":"60c2c17b","7143":"60c2c17b","8795":"544451f8","9106":"60c2c17b"}[chunkId] + ".chunk.css";
};